import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { isFedRamp } from '@atlassian/atl-context';
import { parseExtensionId } from '../utils';
var packageVersion = "32.14.0";
export var COMMERCIAL_SENTRY_DSN = 'https://1210cfc4338849588134f2c80b99f75c@o55978.ingest.sentry.io/5988824';
export var FEDRAMP_SENTRY_DSN = 'https://a377d38318350e08236b26b7b13c8016@sentry.atlassian-us-gov-mod.com/23';
export var captureAndReportError = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref) {
    var error, environment, errorExtensionDetails, page, errorInfo, tracing, module, BrowserClient, Hub, dsn, client, hub;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          error = _ref.error, environment = _ref.environment, errorExtensionDetails = _ref.errorExtensionDetails, page = _ref.page, errorInfo = _ref.errorInfo, tracing = _ref.tracing;
          _context2.prev = 1;
          _context2.next = 4;
          return import('@sentry/browser');
        case 4:
          module = _context2.sent;
          BrowserClient = module.BrowserClient, Hub = module.Hub; // From https://sentry.io/settings/atlassian-2y/projects/forge-ui/keys/ and https://sentry.prod.services.kitt-inf-us-gov-mod.net/settings/sentry/projects/forge-ui/keys
          dsn = isFedRamp() ? FEDRAMP_SENTRY_DSN : COMMERCIAL_SENTRY_DSN;
          client = new BrowserClient({
            environment: environment,
            dsn: dsn,
            release: "forge-ui@".concat(packageVersion)
          });
          hub = new Hub(client);
          hub.withScope( /*#__PURE__*/function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(scope) {
              var breadcrumbs, _errorInfo$componentS, _errorExtensionDetail, appIdFromId;
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    if (tracing) {
                      breadcrumbs = tracing.getBreadcrumbs();
                      breadcrumbs.forEach(function (bc) {
                        return scope.addBreadcrumb(bc, 20);
                      });
                    }
                    if (errorInfo) {
                      scope.setExtra('componentTrace', {
                        errorInfo: errorInfo,
                        componentStack: errorInfo === null || errorInfo === void 0 || (_errorInfo$componentS = errorInfo.componentStack) === null || _errorInfo$componentS === void 0 ? void 0 : _errorInfo$componentS.substring(0, 1000)
                      });
                    }
                    scope.setTag('extensionPoint', page);
                    if (errorExtensionDetails) {
                      scope.setExtra('extensionProperties', errorExtensionDetails.properties);
                      try {
                        appIdFromId = parseExtensionId((_errorExtensionDetail = errorExtensionDetails.id) !== null && _errorExtensionDetail !== void 0 ? _errorExtensionDetail : '').appId;
                        if (appIdFromId) {
                          scope.setTag('appId', appIdFromId);
                        }
                      } catch (e) {
                        // parseExtensionId() uses parse() form @atlassian/cs-ari, which throws an error if the ID is not valid
                      }
                      if (errorExtensionDetails.environmentType) {
                        scope.setTag('forgeEnvironment', errorExtensionDetails.environmentType);
                      }
                      if (errorExtensionDetails.type) {
                        scope.setTag('extensionType', errorExtensionDetails.type);
                      }
                      if (errorExtensionDetails.appOwnerAccountId) {
                        scope.setTag('appOwner', errorExtensionDetails.appOwnerAccountId);
                      }
                    }
                    hub.captureException(error);
                  case 5:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }));
            return function (_x2) {
              return _ref3.apply(this, arguments);
            };
          }());
          return _context2.abrupt("return", client.close());
        case 13:
          _context2.prev = 13;
          _context2.t0 = _context2["catch"](1);
        case 15:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[1, 13]]);
  }));
  return function captureAndReportError(_x) {
    return _ref2.apply(this, arguments);
  };
}();
export { TracingProvider, useTracingContext } from './tracing';